module.exports = __webpack_public_path__ + "media/images/challenges/sony-talent-league-edition-ii/minus-icon-5527a55e1ce5945501952d01d2bcd319.svg";